<template>
  <div class="release-log-viewer">
    <div class="current-release">当前版本：V{{info.version}}</div>
    <a-input v-model:value="keyword" allow-clear :maxlength="100" placeholder="输入版本号、标题或更新内容" aria-label="搜索版本日志" />
    <div class="release-search-count" role="status">{{keyword.trim() ? '找到 '+filteredLogs.length+' 个版本' : '共 '+filteredLogs.length+' 个版本'}}<span v-if="keyword.trim()"> · 多个关键词可用空格分开</span></div>
    <div class="release-log-results">
      <a-empty v-if="!filteredLogs.length" :description="keyword.trim() ? '没有找到匹配的版本记录，请更换关键词' : '暂无版本记录'" />
      <div v-for="(item,index) in filteredLogs" :key="item.version+'-'+index" class="release-log">
        <div class="release-log-header"><strong><Highlight :text="'V'+item.version" :query="keyword" /></strong><span>{{item.releaseDate}}</span></div>
        <div class="release-log-title"><Highlight :text="item.title" :query="keyword" /></div>
        <ul><li v-for="(change,changeIndex) in item.changes" :key="changeIndex"><Highlight :text="change" :query="keyword" /></li></ul>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import {computed,defineComponent,h,ref} from 'vue'
import type {ReleaseInfo} from '@/utils/release'
import {filterReleaseLogs,highlightReleaseText} from '@/utils/releaseLogSearch'
const props=defineProps<{info:ReleaseInfo}>()
const keyword=ref('')
const filteredLogs=computed(()=>filterReleaseLogs(props.info.logs,keyword.value))
// 使用文本节点渲染，不将搜索词或更新内容作为HTML插入。
const Highlight=defineComponent({
  props:{text:{type:String,default:''},query:{type:String,default:''}},
  setup:props=>()=>h('span',highlightReleaseText(props.text,props.query).map(part=>part.matched?h('mark',{class:'release-search-mark'},part.text):part.text))
})
</script>
<style scoped>
.current-release{margin-bottom:16px;font-size:16px;font-weight:bold}
.release-search-count{margin:8px 0;color:#666;font-size:12px}
.release-log-results{max-height:60vh;overflow-y:auto;overflow-wrap:anywhere}
.release-log{padding:14px 0;border-top:1px solid #eee}
.release-log-header{display:flex;justify-content:space-between;gap:12px;flex-wrap:wrap}
.release-log-title{margin-top:8px;font-weight:bold}
.release-log ul{margin:8px 0 0;padding-left:22px}
.release-log-viewer :deep(.release-search-mark){background:var(--admin-skin-soft,#fff1b8);color:var(--activeColor,#874d00);padding:0 1px;border-radius:2px}
</style>
